const config = {
    apiEndPoint: "http://localhost:3001/",
    // apiEndPoint : "http://194.163.178.244:3001/",
    pageCount: "10"

}
export default config;